export const PasswordChange = {
  Title: 'Změna hesla',
  CurrentPassword: 'Aktuální heslo',
  NewPassword: 'Nové heslo',
  ConfirmNewPassword: 'Potvrďte nové heslo',
  Submit: 'Změnit heslo',
  PasswordChanged: 'Heslo změněno',
};
